import { AiAssistantPanel } from "@/components/ai-assistant/AiAssistantPanel.tsx";
import { useAiAssistantAvailable } from "@/components/ai-assistant/use-ai-assistant-available.hook.ts";
import Sidebar from "@/components/sidebar/Sidebar.tsx";
import ImpersonationBanner from "@/layouts/ImpersonationBanner.tsx";
import { useMentionsHook } from "@/hooks/use-mention.hook.ts";
import { useScrollMemory } from "@/hooks/use-restoration-scroll.hook.tsx";
import { useAppRoutes } from "@/routes/use-routes.hook.ts";
import { useEmployeeAppConfigStore } from "@/stores/employee.store.ts";
import { useAppTheme } from "@/themes/app-context.ts";
import { useRef } from "react";
import { Outlet } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export default function AppLayout() {
  const layoutTheme = useAppTheme("layout");
  const { useMentionStyles, useMentionClickHandler } = useMentionsHook();
  const mainRef = useRef<HTMLElement>(null);

  useScrollMemory(mainRef);

  useMentionClickHandler();
  useMentionStyles();

  const { isFullScreenRoute } = useAppRoutes();
  const isAiAssistantAvailable = useAiAssistantAvailable();
  const { aiAssistantIsOpen, setAiAssistantIsOpen } = useEmployeeAppConfigStore();

  return (
    <>
      <div className="flex h-full w-screen flex-col print:h-auto print:block print:overflow-visible">
        <ImpersonationBanner />
        <div
          className={twMerge(
            "min-h-0 flex-1 print:h-auto print:block print:overflow-visible",
            layoutTheme.base
          )}
        >
          {!isFullScreenRoute && <Sidebar />}
          <main
            ref={mainRef}
            className={twMerge(
              "print:w-full print:h-auto print:overflow-visible",
              layoutTheme.main
            )}
          >
            <Outlet />
          </main>
          {isAiAssistantAvailable && (
            <AiAssistantPanel
              isOpen={aiAssistantIsOpen && !isFullScreenRoute}
              onClose={() => setAiAssistantIsOpen(false)}
            />
          )}
        </div>
      </div>
    </>
  );
}
